var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.025.312H2.797A2.489 2.489 0 00.312 2.804v14.33a2.489 2.489 0 002.485 2.493h24.228a2.489 2.489 0 002.485-2.492V2.803A2.489 2.489 0 0027.025.312z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.623
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.467 7.37a8.931 8.931 0 00-2.22-.844l.034-.156h3.4c.461.016.835.155.957.647l.74 3.534.226 1.064 2.07-5.245h2.234l-3.322 7.683H5.351L3.467 7.37zm9.085 6.692H10.44L11.76 6.37h2.113l-1.322 7.692zm7.662-7.504l-.287 1.661-.191-.082a3.784 3.784 0 00-1.575-.294c-.834 0-1.208.335-1.217.663 0 .36.453.597 1.192.949 1.218.548 1.783 1.219 1.774 2.095-.017 1.595-1.46 2.626-3.679 2.626-.948-.008-1.861-.197-2.357-.41l.296-1.726.278.123c.687.287 1.14.41 1.983.41.609 0 1.261-.238 1.27-.754 0-.335-.278-.58-1.096-.957-.8-.368-1.87-.982-1.852-2.087.009-1.497 1.478-2.544 3.566-2.544.817 0 1.479.172 1.895.327zm2.81 4.779h1.756c-.087-.385-.487-2.226-.487-2.226l-.148-.663c-.104.287-.286.753-.278.737l-.843 2.152zm2.609-4.967l1.705 7.692H25.38s-.192-.884-.253-1.154h-2.713l-.444 1.154h-2.218l3.14-7.054c.217-.499.6-.638 1.105-.638h1.635z",
    fill: "#171E6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.c7ee3457d24554aee87b848b244437f0.svg";
export { ForwardRef as ReactComponent };